import { render, staticRenderFns } from "./ProductionOrders.vue?vue&type=template&id=131d4b50&scoped=true"
import script from "./ProductionOrders.vue?vue&type=script&lang=js"
export * from "./ProductionOrders.vue?vue&type=script&lang=js"
import style0 from "./ProductionOrders.vue?vue&type=style&index=0&id=131d4b50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131d4b50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VPagination,VSelect,VTextField})
